module.exports = __webpack_public_path__ + "img/opet-infographic-08.16f37cf0.jpg";